import * as vp from 'vopay';
import { ReactNode, createContext, useContext, useState } from 'react';

export type PartnerData = {
  accountId: string;

  username: string;
  loginUsername: string;
  partnerType: vp.PartnerType | '';
  partnerTypeLabel: vp.PartnerTypeLabel;
  domain: string;
  userRole: string;
  JWT: string;
  isRoleAdmin: boolean;
  isRoleViewOnly: boolean;
  isInsideSales: boolean;
};
export type PartnerDataCtx = {
  response: {
    accountId: string;
    username: string;
    loginUsername: string;
    partnerType: vp.PartnerType | '';
    partnerTypeLabel: vp.PartnerTypeLabel;
    domain: string;
    userRole: string;
    isRoleAdmin: boolean;
    isRoleViewOnly: boolean;
    isInsideSales: boolean;
  };
  setPartnerData: (partnerData: PartnerData) => void;
  reset: () => void;
};

export const PartnerDataContext = createContext<PartnerDataCtx>({
  response: {
    accountId: '',

    username: '',
    loginUsername: '',
    partnerType: '',
    partnerTypeLabel: '',
    domain: '',
    userRole: '',
    isRoleAdmin: false,
    isRoleViewOnly: false,
    isInsideSales: false,
  },
  setPartnerData: () => {},
  reset: () => {},
});

export const PartnerDataProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [partnerData, setPartnerData] = useState<PartnerData>({
    accountId: '',
    username: '',
    loginUsername: '',
    partnerType: '',
    partnerTypeLabel: '',
    domain: '',
    userRole: '',
    JWT: '',
    isRoleAdmin: false,
    isRoleViewOnly: false,
    isInsideSales: false,
  });

  return (
    <PartnerDataContext.Provider
      value={{
        response: partnerData,
        setPartnerData,
        reset: () =>
          setPartnerData({
            accountId: '',
            username: '',
            loginUsername: '',
            partnerType: '',
            partnerTypeLabel: '',
            domain: '',
            userRole: '',
            JWT: '',
            isRoleAdmin: false,
            isRoleViewOnly: false,
            isInsideSales: false,
          }),
      }}
    >
      {children}
    </PartnerDataContext.Provider>
  );
};

export const usePartnerData = (): PartnerDataCtx => useContext(PartnerDataContext);
